export default __webpack_public_path__ + "static/media/workshop.f998d17c.jpg";